// extracted by mini-css-extract-plugin
export default {"paymentSection":"C8-z"};